export default {
  addCui(state, cui) {
    this.state.formInputs.cui = cui;
  },
  setIsServiceError(state, isServiceError) {
    this.state.isServiceError = isServiceError;
  },
  addRegisterNum(state, registerNum) {
    this.state.formInputs.registerNum = registerNum;
  },
  toggleIsSameAddress(state) {
    this.state.formInputs.isSameAddress = !state.formInputs.isSameAddress;
  },
  toggleHasContact(state) {
    this.state.formInputs.hasContact = !state.formInputs.hasContact;
  },
  setIsOwnerResponsibleCorresp(state, isOwnerResponsibleCorresp) {
    this.state.formInputs.isOwnerResponsibleCorresp = isOwnerResponsibleCorresp;
  },
  addCompanyName(state, companyName) {
    this.state.formInputs.companyName = companyName;
  },
  addAddressCorresp(state, addressCorresp) {
    this.state.formInputs.addressCorresp = addressCorresp;
  },
  addPostalCodeCorresp(state, postalCodeCorresp) {
    this.state.formInputs.postalCodeCorresp = postalCodeCorresp;
  },
  addAddress(state, address) {
    this.state.formInputs.address = address;
  },
  addCountyCorresp(state, countyCorresp) {
    this.state.formInputs.countyCorresp = countyCorresp;
  },
  addCityCorresp(state, cityCorresp) {
    this.state.formInputs.cityCorresp = cityCorresp;
  },
  addAppellative(state, appellative) {
    this.state.formInputs.appellative = appellative;
  },
  addPosition(state, position) {
    this.state.formInputs.position = position;
  },
  addFirstName(state, firstName) {
    this.state.formInputs.firstName = firstName;
  },
  addLastName(state, lastName) {
    this.state.formInputs.lastName = lastName;
  },
  addEmail(state, email) {
    this.state.formInputs.email = email;
  },
  addPhone(state, phone) {
    this.state.formInputs.phone = phone;
  },
  addContactAppellative(state, appellative) {
    this.state.formInputs.contact.appellative = appellative;
  },
  addContactPosition(state, position) {
    this.state.formInputs.contact.position = position;
  },
  addContactFirstName(state, firstName) {
    this.state.formInputs.contact.firstName = firstName;
  },
  addContactLastName(state, lastName) {
    this.state.formInputs.contact.lastName = lastName;
  },
  addContactEmail(state, email) {
    this.state.formInputs.contact.email = email;
  },
  addContactPhone(state, phone) {
    this.state.formInputs.contact.phone = phone;
  },
  addIban(state, iban) {
    this.state.formInputs.iban = iban;
  },
  addBank(state, bank) {
    this.state.formInputs.bank = bank;
  },
  addDate(state, date) {
    this.state.formInputs.date = date;
  },
  addDateObject(state, date) {
    this.state.formInputs.dateObject = date;
  },
  addAmount(state, amount) {
    this.state.formInputs.amount = amount;
  },
  addFileName(state, fileName) {
    this.state.formInputs.fileName = fileName;
  },
  addSimpleInputField(state, [inputName, value]) {
    this.state.formInputs[inputName] = value;
  },
  isSimpleInputFieldValid(state, [inputName, isValid]) {
    this.state.isFormValid[inputName] = isValid;
  },

  
  isCuiValid(state, isValid) {
    this.state.isFormValid.cui = isValid;
  },
  isAddressCorrespValid(state, isValid) {
    this.state.isFormValid.addressCorresp = isValid;
  },
  isPostalCodeCorrespValid(state, isValid) {
    this.state.isFormValid.postalCodeCorresp = isValid;
  },
  isAddressValid(state, isValid) {
    this.state.isFormValid.address = isValid;
  },
  isRegisterNumValid(state, isValid) {
    this.state.isFormValid.registerNum = isValid;
  },
  isCityCorrespValid(state, isValid) {
    this.state.isFormValid.cityCorresp = isValid;
  },
  isCountyCorrespValid(state, isValid) {
    this.state.isFormValid.countyCorresp = isValid;
  },
  isAppellativeValid(state, isValid) {
    this.state.isFormValid.appellative = isValid;
  },
  isPositionValid(state, isValid) {
    this.state.isFormValid.position = isValid;
  },
  isFirstNameValid(state, isValid) {
    this.state.isFormValid.firstName = isValid;
  },
  isLastNameValid(state, isValid) {
    this.state.isFormValid.lastName = isValid;
  },
  isEmailValid(state, isValid) {
    this.state.isFormValid.email = isValid;
  },
  isPhoneValid(state, isValid) {
    this.state.isFormValid.phone = isValid;
  },
  isContactAppellativeValid(state, isValid) {
    this.state.isFormValid.contact.appellative = isValid;
  },
  isContactPositionValid(state, isValid) {
    this.state.isFormValid.contact.position = isValid;
  },
  isContactFirstNameValid(state, isValid) {
    this.state.isFormValid.contact.firstName = isValid;
  },
  isContactLastNameValid(state, isValid) {
    this.state.isFormValid.contact.lastName = isValid;
  },
  isContactEmailValid(state, isValid) {
    this.state.isFormValid.contact.email = isValid;
  },
  isContactPhoneValid(state, isValid) {
    this.state.isFormValid.contact.phone = isValid;
  },
  isIbanValid(state, isValid) {
    this.state.isFormValid.iban = isValid;
  },
  isBankValid(state, isValid) {
    this.state.isFormValid.bank = isValid;
  },
  isDateValid(state, isValid) {
    this.state.isFormValid.date = isValid;
  },
  isAmountValid(state, isValid) {
    this.state.isFormValid.amount = isValid;
  },
  incrementWizardStep() {
    this.state.wizardStep++;
  },
  decrementWizardStep() {
    this.state.wizardStep--;
  }
}